import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../actions/ts_overlay_actions.js';
import {updateModal} from '../../actions/modal.js';
import {
  Button,
  Modal
} from 'react-bootstrap';
import {
  CirclePicker
} from 'react-color';
import Draggable from 'react-draggable';
//import HTML2Canvas from 'html2canvas';
import ReactDOM from 'react-dom';
import {getGameTitle, getMapTitle} from '../../utils/maps/titleUtil.js';
import ClearCanvas from './clear.js';
import Stamps from './stamps/';
import Undo from './undo.js';
import Colors from './colors.js';
import Utility from './utility.js';
var Tools = React.createClass({

  changeColor(color) {
    var {dispatch,overlay} = this.props;
    dispatch(changeColor(color,overlay.color1,overlay.color2));
  },

  clearDraw(canvas) {
    var {dispatch} = this.props;
      var modalContent = <ClearCanvas/>;
        if (canvas.history && canvas.history.length > 0)
        {
        dispatch(updateModal(true,modalContent));
      }
    },

    showStamps() {
      var {dispatch} = this.props;
      var modalContent = <Stamps/>;
      dispatch(updateModal(true,modalContent));
      },


  toggleDownloadButton(currentUser,map)
  {
if (currentUser && currentUser.uid && currentUser.emailVerified && map.map != 'SKETCH')
    return ( <Link onClick={(event) => {
      this.takeScreenShot();
    }} className="navbar-brand">
     <span><i className="fa fa-download fa-fw"></i></span>
    </Link>)

  },

  takeScreenShot(){
    var {
      map,
    } = this.props;

    var title = document.getElementById("hideTitle");
    title.className="";
    var game = map.game.toString().toLowerCase()
    var map = map.map.toString().toLowerCase()
    var fileName = "TS_" + game + "_" + map + ".jpg";
    HTML2Canvas(document.getElementById("target"), {
      background :'#000',
      onrendered: function (canvas) {
      var a = document.createElement('a');
      // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
      a.href = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
      a.download = fileName;
      a.click();
    }
})
  title.className="hide";
},

  render() {
    var {overlay,map,currentUser,canvas,stamp} = this.props;
    var img = stamp.stamp;
    var cellStyle= "fa-2x pointerCursor stamp";
    if(overlay.color == 'blue'){
      cellStyle ="fa-2x icon-blue pointerCursor stamp";
    }
    if(overlay.color == 'red'){
        cellStyle ="fa-2x icon-red pointerCursor stamp";
    }
    var divBlackCircle = {
      float: 'right'
    };
    var clearColor = {
      color:'gray'
    };
    if (canvas.history && canvas.history.length > 0)
    {
     clearColor = {
      color:'white'
    };
    }
    var stampDisplay;
    if (currentUser && currentUser.uid && currentUser.emailVerified){
      stampDisplay = <Link onClick={(event) => {this.showStamps();}} className="navbar-brand"><span><div style={divBlackCircle}><b><span className={cellStyle}>{img}</span></b></div></span></Link>;
    }
    return (
             <span>
               <Link onClick={(event) => {
                 this.clearDraw(canvas);
               }} className="navbar-brand">
                 <span>
                   <div style={divBlackCircle}><b><span style={clearColor}>X</span></b></div>
                 </span>
               </Link>
               <Undo/>
                <Colors/>
                {stampDisplay}


             {/*this.toggleDownloadButton(currentUser, map)*/}
           </span>
    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay, map: state.map, currentUser: state.currentUser, canvas:state.canvas, stamp:state.stamp
  }
})(Tools);



// WEBPACK FOOTER //
// ./src/app/components/tools/index.js